<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table 
                            :settings="tableConfig" 
                            :table-items="tableItems" 
                            @load-items="getTableData" 
                            @new-item="modalCreate" 
                            @row-click="editItem" 
                            @export="exportFile" 
                            ref="gofixTable">
                            <template slot="gofix_table:device_tag" slot-scope="row">
                                {{row.item.device_tag ? row.item.device_tag : "N/A"}}
                            </template>
                            <template slot="gofix_table:name_properties" slot-scope="row">
                                {{row.item.name_properties ? row.item.name_properties : "N/A"}}
                            </template>
                            <template slot="gofix_table:timestamp" slot-scope="row">
                                {{row.item.timestamp ? row.item.timestamp : "" | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:time_log" slot-scope="row">
                                {{row.item.timestamp ? row.item.timestamp : "" | formatDatebyMoment("HH:mm","HH:mm")}}
                            </template>
                            <template slot="gofix_table:remark" slot-scope="row">
                                {{row.item.remark ? row.item.remark : ""}}
                            </template>
                            <template slot="gofix_table:consumption" slot-scope="row">
                                {{ $accounting.formatNumber(row.item.consumption, 3, " ") }}
                            </template>
                            <template slot="gofix_table:metering_devices.unit_of_measurement" slot-scope="row">
                                {{ row.item.unit_of_measurement}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-reading" :title="titleModal" hide-footer :centered="true" ref="modal-reading">
                <b-form class="formV2">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-tree 
                                label="Facilities" 
                                :options="dataDeviceModal" 
                                :load-options="loadParentOptions" 
                                v-model="metering_devices_selected.device" 
                                :normalizer="normalizerParent" 
                                search-nested 
                                valueFormat="object" 
                                @change="updateitemPrev" />
                            </gofix-form-tree>
                        </b-col>
                    </b-row>
                    <div class="boxInfoSupplier">
                        <b-row>
                            <b-col md="12">
                                <div class="content-info">
                                    <label>Location</label>
                                    <div class="content">{{ metering_devices_selected.location ? metering_devices_selected.location : '--' }}</div>
                                </div>
                            </b-col>
                            <b-col md="12">
                                <div class="content-info">
                                    <label>Previous Reading</label>
                                    <div class="content">{{ itemPrev && itemPrev.value ? itemPrev.value : '--' }}</div>
                                </div>
                            </b-col>
                            <b-col md="12">
                                <div class="content-info">
                                    <label>UOM</label>
                                    <div class="content">{{ metering_devices_selected.unit_of_measurement ? metering_devices_selected.unit_of_measurement : '--' }}</div>
                                </div>
                            </b-col>
                            <b-col md="12">
                                <div class="content-info">
                                    <label>Previous Date & Time</label>
                                    <div class="content">{{ itemPrev && itemPrev.timestamp ? itemPrev.timestamp : '' | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</div>
                                </div>
                            </b-col>
                            <b-col md="12">
                                <div v-if="metering_devices_selected.device" class="content-info">
                                    <label>Consumption</label>
                                    <div class="content">{{ metering_devices_selected.device && metering_devices_selected.device.lastLog && metering_devices_selected.device.lastLog.consumption }}</div>
                                </div>
                            </b-col>
                            <b-col md="6" class="mt-30">
                                <gofix-form-input-number 
                                    v-if="metering_devices_selected.is_cumulated" l
                                    abel="Value" 
                                    :include-thousands-separator="false" 
                                    v-model="dataLog.value" />
                                <gofix-form-input-number 
                                    v-else 
                                    allowNegative 
                                    label="Value" 
                                    :include-thousands-separator="false" 
                                    v-model="dataLog.value" />
                            </b-col>
                            <b-col md="12">
                                <div class="content-info">
                                    <label>UOM</label>
                                    <div class="content">{{ metering_devices_selected.unit_of_measurement ?metering_devices_selected. unit_of_measurement : '--' }}</div>
                                </div>
                            </b-col>
                            <b-col md="12">
                                <b-row>
                                    <b-col md="6">
                                        <div class="content-info">
                                            <gofix-form-input-date 
                                                v-model="dataLog.current_date" 
                                                :max-date='current_date' 
                                                label="Current Date" />
                                        </div>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-input-time label="Current Time" v-model="dataLog.current_time"></gofix-form-input-time>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="12" class="mt-30">
                                <gofix-form-input label="Remarks" v-model="dataLog.remark"></gofix-form-input>
                            </b-col>
                        </b-row>
                    </div>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button :disabled="$disabledCreateOrUpdate(dataLog, $accessModule.electricity_reading_log)" label="SUBMIT" @click="checkValue" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal modal-class="modal-remove-reading-log-custom-with" :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-Check">
                <div class="center">
                    <span v-if="metering_devices_selected.is_cumulated">{{ msg.previous }}<strong> {{ itemPrev.value }}</strong></span>
                    <span v-else>{{ msg.threshold }}<strong> {{ $accounting.formatNumber(metering_devices_selected.threshold, 3, " ") }}</strong></span><br />
                    <span>Would you like to proceed</span>?
                </div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="$bvModal.hide('modal-Remove')">No
                    </b-button>
                    <b-button class="custom-btn" @click="save" :disabled="isAction">Yes</b-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>
import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'

const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};

import moment from 'moment';
var accounting = require('accounting');
export default {
    name: 'electricity-reading-log',
    components: {},
    data() {
        return {
            tableConfig: {
                name: 'utilities-management-electricity-reading-logs',
                controls: {
                    create: this.$checkRole(this.$accessModule.electricity_reading_log, 'create'),
                    delete: null,
                },
                filter: JSON.parse(JSON.stringify(filters['electricity_reading_log'])),
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
            },
            tableItems: [],
            isAction: false,
            dataDeviceModal: [],
            metering_devices_selected: {
                device: null,
                location: null,
                unit_of_measurement: null,
                threshold: null,
                is_cumulated: 0
            },
            unit_of_measurement: null,
            threshold: null,
            titleModal: 'Create New Reading',
            current_date: new Date(),
            itemPrev: {
                timestamp: null,
                value: null
            },
            items: [],
            dataLog: {
                electricity_id: '',
                timestamp: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                current_date: new Date(),
                current_time: moment(new Date()).format("HH:mm"),
                value: '',
                reader_id: '',
                remark: ''
            },
            editID: null,
            msg: {
                previous: 'Your reading is lower than the previous reading',
                threshold: 'Your reading is higher than threshold'
            }
        }
    },
    watch: {
        "dataLog.current_date": function(val, old) {
            this.updateTimeStamp();
        },
        "dataLog.current_time": function(val, old) {
            this.updateTimeStamp();
        },
        ClientContractID: function(val, old) {
            this.getParent();
        }
    },
    computed: {
        ...mapGetters({
            Items: 'ElectricityMeterReadingLogController/Items',
            ClientContractID: 'ContractController/ClientContractID'
        })
    },
    created() {
        this.getParent();
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            await this.$store.dispatch("ElectricityMeterReadingLogController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the Reading log", "danger");
                    reject();
                })
        },
        exportFile() {
            this.$store.dispatch('ElectricityMeterReadingLogController/exportFile', this.Items.pages)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ElectricityMeterReadingLog.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        updateTimeStamp() {
            let a = this.dataLog.current_date.toDateString() + " " + this.dataLog.current_time;
            this.dataLog.timestamp = moment(new Date(a)).format("YYYY-MM-DD HH:mm:ss");
        },
        modalCreate() {

            this.titleModal = 'Create New Reading'
            this.$refs['modal-reading'].show()
            this.metering_devices_selected = {
                device: null,
                location: null,
                unit_of_measurement: null,
                threshold: null
            }
            this.itemPrev.timestamp = null
            this.itemPrev.value = null

            this.dataLog.electricity_id = '';
            this.dataLog.value = '';
            this.dataLog.remark = '';
            this.dataLog.timestamp = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            this.dataLog.current_date = new Date();
            this.dataLog.current_time = moment(new Date()).format("HH:mm");

            // reset id edit
            this.editID = null;
            this.dataLog.id = null;
        },
        editItem(value) {

            this.titleModal = 'Edit Reading Log';
            this.metering_devices_selected = {
                device: null,
                location: null,
                unit_of_measurement: null,
                threshold: null
            }

            this.itemPrev = {
                timestamp: null,
                value: null
            };

            // reset id edit
            this.editID = null;

            if (value) {

                this.$store.dispatch('ElectricityMeterReadingLogController/getItem', value.id)
                    .then(response => {
                        let ts = response.timestamp;
                        this.dataLog.id = response.id
                        this.dataLog.electricity_id = response.electricity_id
                        this.dataLog.timestamp = response.timestamp
                        this.dataLog.value = String(response.value)
                        this.dataLog.reader_id = response.reader_id
                        this.dataLog.remark = response.remark

                        this.metering_devices_selected.device = response.metering_devices
                        this.metering_devices_selected.is_cumulated = response.metering_devices.is_cumulated
                        this.metering_devices_selected.threshold = response.metering_devices.threshold
                        this.dataLog.current_date = new Date(ts);
                        this.dataLog.current_time = moment(new Date(ts)).format("HH:mm");

                        if (response.lastLog) {
                            this.itemPrev.timestamp = response.lastLog.timestamp
                            this.itemPrev.value = response.lastLog.value
                        }
                        this.metering_devices_selected.unit_of_measurement = response.metering_devices && response.metering_devices.unit_of_measurement ? response.metering_devices.unit_of_measurement : ''

                        this.editID = value.id;

                        this.metering_devices_selected.location = (response.metering_devices && response.metering_devices.properties && response.metering_devices.properties.name) ? response.metering_devices.properties.name : ''

                        this.$refs['modal-reading'].show()
                    })
                    .catch(error => {
                        console.log(error)
                        this.$alertNotification("Please select item edit!!", "danger");
                    })
            } else {
                this.$alertNotification("Please select item edit!!", "danger");
            }
        },
        getParent() {
            global.axios(`api/electricity-metering-devices/tree/1`, {
                    method: "GET",
                    params: {
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : 0
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    this.dataDeviceModal = response.data.data;
                })
                .catch(error => console.log(error));
        },
        loadParentOptions({ action, parentNode, callback }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return;
                }
                if (parentNode.data.isBatch) {
                    global
                        .axios(
                            `api/electricity-metering-devices/tree/${parentNode.data.id}`, {
                                method: "GET",
                                headers: {
                                    Accept: "application/json"
                                }
                            }
                        )
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data;
                                callback();
                            });
                        });
                } else {
                    parentNode.children = [];
                    callback();
                }
            }
        },
        normalizerParent(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.device_tag,
                    children: node.children,
                };
            return {
                id: node.data.id,
                label: node.device_tag,
                children: undefined
            };
        },
        updateitemPrev(value) {
            this.itemPrev.timestamp = ''
            this.itemPrev.value = ''
            if (value && value.lastLog) {
                this.itemPrev.timestamp = value.lastLog.timestamp
                this.itemPrev.value = value.lastLog.value
            }

            this.metering_devices_selected.location = value && value.properties && value.properties.name ? value.properties.name : '--'
            this.metering_devices_selected.unit_of_measurement = value && value.unit_of_measurement ? value.unit_of_measurement : ''
            this.metering_devices_selected.threshold = value && value.threshold ? value.threshold : null
            this.metering_devices_selected.is_cumulated = value && value.is_cumulated ? value.is_cumulated : 0
        },
        checkValue() {
            if (!this.metering_devices_selected.device) {
                return this.$alertNotification("Please select one Device!!", "danger");
            }

            if (!this.dataLog.value) {
                return this.$alertNotification("Value enter invalid!!", "danger");
            }

            let bug = false;
            if (this.metering_devices_selected.is_cumulated && this.dataLog.value < this.itemPrev.value) {
                bug = true;
            }

            if (!this.metering_devices_selected.is_cumulated && this.metering_devices_selected.threshold && this.dataLog.value > this.metering_devices_selected.threshold) {
                bug = true;
            }

            if (bug) {
                this.$refs['modal-Check'].show();
                return;
            }

            this.save();
        },
        save() {
            if (this.isAction) return;
            this.$refs['modal-Check'].hide();
            this.isAction = true

            this.dataLog.electricity_id = this.metering_devices_selected.device.id
            let dataLogClone = Object.assign({}, this.dataLog);
            delete dataLogClone.current_date
            delete dataLogClone.current_time
            if (!this.editID) {
                this.$store.dispatch("ElectricityMeterReadingLogController/saveMeterReadingLog", dataLogClone)
                    .then(data => {
                        this.isAction = false
                        this.$alertNotification(this.$notificationV2('adding', 'electricity_reading_logs'));
                        this.$refs['modal-reading'].hide();
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.isAction = false
                        if(error.response) this.$alertNotification("Error", "danger");
                    })
            } else {
                this.$store.dispatch("ElectricityMeterReadingLogController/updateMeterReadingLog", { id: this.editID, data: dataLogClone })
                    .then(data => {
                        this.isAction = false
                        this.$alertNotification(this.$notificationV2('editing', 'electricity_reading_logs'));
                        this.$refs['modal-reading'].hide();
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.isAction = false
                        if(error.response) this.$alertNotification("Error", "danger");
                    })
            }
            this.getParent()
        }
    }
}
</script>